import logoBlack from "@hosttools/frontend/assets/logo-black.svg";
import {Box, Image} from "@hosttools/frontend/components";
import type React from "react";
import {memo} from "react";
import {Link} from "react-router-dom";

const logoSource = {uri: logoBlack};

const OnboardingHeader: React.FC = () => {
    return (
        <Box className="hidden md:flex pt-4 md:pt-12 pl-5 md:pl-24 flex-shrink-0 flex-grow-0">
            <Link to="/">
                <Image
                    alt="Host Tools Logo"
                    className="w-[110px] h-[22px] md:w-[172px] md:h-[34px]"
                    source={logoSource}
                />
            </Link>
        </Box>
    );
};

export default memo(OnboardingHeader);
